const style = {
  button: {
    display: `block`,
    cursor: `pointer`,
    padding: `5px 25px`,
    texDecoration: `none`,
    fontSize: `12px`,
    textAlign: `center`
  },
  red: {
    color: `white`,
    background: `#ad5151`,
    border: `2px solid #AD5251`,
    ':hover': {
      background: `white`,
      color: `#ad5151`
    }
  },
  redActive: {
    background: `white`,
    color: `#ad5151`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/style/buttons.js